<template>
  <wms-dual-auto-complate
    :span="span"
    popper-class="my-autocomplete"
    :value-key="valueKey"
    :prop="prop"
    :fuzzy-field="displayFuzzyField"
    :exact-field="displayExactField"
    :fuzzy-value.sync="form[formFuzzyField]"
    :exact-value.sync="form[formExactField]"
    :optionList="newOptionList"
    :valueKeys="valueKeys"
    :label="label"
    haveSlotScope
    v-bind="$attrs"
    v-on="$listeners">
    <template slot-scope="scope">
      <template v-if="$slots.default">
        <slot v-bind="scope"></slot>
      </template>
      <template v-else>
        <div class="name">{{ scope.option.shopCode }}</div>
        <div class="addr">{{ scope.option.shopName }}</div>
      </template>
    </template>
  </wms-dual-auto-complate>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'WmsDualShop',
  props: {
    form: { type: Object, required: true },
    visible: { type: Boolean, default: true },
    span: { type: Number, default: 6 },
    prop: { type: String, default: 'shopName' },
    label: { type: String, default: '门店' },
    optionList: { type: Array, default: () => [] },
    displayFuzzyField: { type: String, default: 'shopName' },
    displayExactField: { type: String, default: 'shopCode' },
    formFuzzyField: { type: String, default: 'shopName' },
    formExactField: { type: String, default: 'shopCode' },
    valueKey: { type: String, default: 'shopName' },
    valueKeys: { type: Array, default: () => ['shopCode', 'shopName'] }
  },

  computed: {
    newOptionList(){
      return this.optionList.length ? this.optionList : this.guestShopList
    },
    ...mapState({
      guestShopList: state => state.guestShop.guestShopList,
    })
  },
  mounted() {
    if (!this.optionList.length) {
      this.$store.dispatch('getGuestShopList')
    }

  }
  // 如果optionList没传就使用默认，
}
</script>
